import { render, staticRenderFns } from "./modalReflexos.vue?vue&type=template&id=8a99144a&scoped=true&"
import script from "./modalReflexos.vue?vue&type=script&lang=js&"
export * from "./modalReflexos.vue?vue&type=script&lang=js&"
import style0 from "./modalReflexos.vue?vue&type=style&index=0&id=8a99144a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99144a",
  null
  
)

export default component.exports